<template>
  <div>
    Please use <a :href="loginSamlUrl">the Login link</a> if you aren't forwarded to login page.
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import queryString from 'querystring';

export default {
  computed: {
    ...mapState('context', ['loginRedirectUrl']),

    returnPath() {
      let returnPath = this.$route.query.returnPath || '/';
      if (returnPath === '/ah-auth/login') returnPath = '/';
      // if returnPath contains /error/ then reassign it to / as we don't want to redirect to error page
      if (returnPath.includes('/error/')) returnPath = '/';
      return returnPath;
    },
    loginSamlUrl() {
      this.setCurrentLoginMethod('ah-auth-saml');
      const query = queryString.stringify({ returnPath: this.returnPath });
      return `${this.loginRedirectUrl}/api/ah-auth/login?${query}`;
    },
  },

  created() {
    window.location.href = this.loginSamlUrl;
  },

  methods: {
    ...mapActions('context', ['setCurrentLoginMethod']),
  },
};
</script>
